import React, { Component } from 'react';
import { GoogleApiWrapper } from 'google-maps-react';
import ReactDOMServer from 'react-dom/server';

export class MapContainer extends Component {
	firstRender = true;

	componentDidMount() {
		this.google = this.props.google;
		if (this.firstRender) {
			this.map = new this.google.maps.Map(this.refs.container, {
				center: { lat: 47.5990953, lng: -122.3369049 },
				zoom: 15
			});

			// Search for Google's office in Australia.
			var request = {
				location: this.map.getCenter(),
				radius: '500',
				query: 'E Cobb Architects'
			};

			var service = new this.google.maps.places.PlacesService(this.map);
			service.textSearch(request, (results, status) => this.callback(results, status));
		} else this.firstRender = false;
	}

	callback(results, status) {
		if (status === this.google.maps.places.PlacesServiceStatus.OK) {
			var innerValue = (
				<div id="content">
					<h1 id="firstHeading" className="firstHeading">
						E Cobb Architects
					</h1>
					<div id="bodyContent">
						<p>99 S Jackson</p>
					</div>
				</div>
			);
			this.map.setCenter(results[0].geometry.location);
			var infowindow = new this.google.maps.InfoWindow({
				content: ReactDOMServer.renderToStaticMarkup(innerValue),
				maxWidth: '200'
			});
			var marker = new this.google.maps.Marker({
				map: this.map,
				title: 'E Cobb Architects',
				animation: this.google.maps.Animation.DROP,
				place: {
					placeId: results[0].place_id,
					location: results[0].geometry.location
				}
			});
			marker.addListener('click', function() {
				infowindow.open(this.map, marker);
			});
		}
	}

	render() {
		return (
			<div style={{ width: this.props.width, height: this.props.height }} ref="container">
				test
			</div>
		);
	}
}

export default GoogleApiWrapper({
	apiKey: 'AIzaSyCtMFu9_LH-FikFsknAqliIu18C7AYgzYQ'
})(MapContainer);



// WEBPACK FOOTER //
// ./src/google/Map.js